import { AnimationType, getNewAnimation } from '@/models/games/BaseAnimation';
import { AnimationData } from '@/models/games/carnivalTreasure/AnimationData';
import { EntityState, PayloadAction } from '@reduxjs/toolkit';
import { Animation, animationAdapter } from './slice';

const init = (
    state: EntityState<Animation, number>,
    action: PayloadAction<{
        hostId: number;
        multiplier?: 2 | 10;
        init: number[];
    }>
) => {
    const { hostId, multiplier, init } = action.payload;
    const data = getNewAnimation(hostId);
    data.HostId = hostId;
    data.Animation = {
        animationType: AnimationType.CT_INIT,
        multiplier: multiplier,
        initialPayouts: init,
    };
    animationAdapter.upsertOne(state, data);
};
const update = (
    state: EntityState<Animation, number>,
    action: PayloadAction<{
        hostId: number;
        multiplier: 2 | 10;
        updatePayouts: number[];
    }>
) => {
    const hostId = action.payload.hostId;
    const multiplier = action.payload.multiplier;
    const newData = getNewAnimation(hostId);
    const oldData = state.entities[hostId];
    if (oldData?.Animation !== undefined) {
        newData.Animation.initialPayouts = oldData.Animation.initialPayouts;
        newData.Animation.multiplier = multiplier;
    }
    newData.Animation.initialPayouts = action.payload.updatePayouts;
    newData.Animation.animationType = AnimationType.CT_ADD;
    return animationAdapter.upsertOne(state, newData);
};
const save = (
    state: EntityState<Animation, number>,
    action: PayloadAction<{
        hostId: number;
        last: AnimationData;
    }>
) =>
    animationAdapter.updateOne(state, {
        id: action.payload.hostId,
        changes: {
            Last: action.payload.last,
        },
    });
const reset = (
    state: EntityState<Animation, number>,
    action: PayloadAction<number>
) =>
    animationAdapter.updateOne(state, {
        id: action.payload,
        changes: getNewAnimation(action.payload),
    });
const exit = (
    state: EntityState<Animation, number>,
    action: PayloadAction<number>
) =>
    animationAdapter.updateOne(state, {
        id: action.payload,
        changes: {
            Animation: undefined,
        },
    });
const add = (
    state: EntityState<Animation, number>,
    action: PayloadAction<number>
) => animationAdapter.upsertOne(state, getNewAnimation(action.payload));
export const animationReducer = {
    init,
    update,
    reset,
    save,
    exit,
    add,
};
